import { db } from '../firebase';
import { collection, doc, getDoc, getDocs } from 'firebase/firestore';

export function getWeekStart(date = new Date()) {
  const d = new Date(date);
  const day = d.getUTCDay();
  const diff = day === 0 ? -6 : 1 - day;
  d.setUTCDate(d.getUTCDate() + diff);
  return d.toISOString().slice(0, 10);
}

// Returns { EUR_GBP, USD_GBP, weekStart, isStale }
// Falls back to most recent available week if current week has not yet been pulled
export async function getCurrentWeekRates() {
  const weekStart = getWeekStart();
  const snap = await getDoc(doc(db, 'exchangeRates', weekStart));
  if (snap.exists()) {
    return { ...snap.data(), weekStart, isStale: false };
  }
  const fallback = await getDocs(collection(db, 'exchangeRates'));
  if (!fallback.empty) {
    const sorted = fallback.docs.sort((a, b) => b.id.localeCompare(a.id));
    const d = sorted[0];
    return { ...d.data(), weekStart: d.id, isStale: true };
  }
  // No rates in Firestore at all yet — use 1:1 as a safe no-op default
  return { EUR_GBP: 1, USD_GBP: 1, weekStart, isStale: true };
}

export function toGBP(amount, currency, rates) {
  const n = Number(amount) || 0;
  if (!currency || currency === 'GBP') return n;
  if (currency === 'EUR') return parseFloat((n * (rates.EUR_GBP || 1)).toFixed(2));
  if (currency === 'USD') return parseFloat((n * (rates.USD_GBP || 1)).toFixed(2));
  return n;
}

export function toEUR(amount, currency, rates) {
  const n = Number(amount) || 0;
  if (currency === 'EUR') return n;
  if (!currency || currency === 'GBP') return parseFloat((n * (rates.GBP_EUR || 1)).toFixed(2));
  return n;
}

export function getRateForCurrency(currency, rates) {
  if (!currency || currency === 'GBP') return 1;
  if (currency === 'EUR') return rates.EUR_GBP || 1;
  if (currency === 'USD') return rates.USD_GBP || 1;
  return 1;
}

export function convertCurrency(amount, from, to, rates) {
  const n = Number(amount) || 0;
  if (from === to) return n;
  const gbp = toGBP(n, from, rates);
  if (to === 'GBP') return gbp;
  if (to === 'EUR') return toEUR(gbp, 'GBP', rates);
  if (to === 'USD') return parseFloat((gbp / (rates.USD_GBP || 1)).toFixed(2));
  return gbp;
}

export function roundToNearest50p(amount) {
  return Math.round(amount * 2) / 2;
}

// Fetch rates for a specific week (used to lock quote calculations to the rate at save time)
export async function getHistoricalRates(weekStart) {
  if (!weekStart) return getCurrentWeekRates();
  const snap = await getDoc(doc(db, 'exchangeRates', weekStart));
  if (snap.exists()) return { ...snap.data(), weekStart, isStale: false };
  return getCurrentWeekRates();
}
